// src/components/PageNavbarMobile/PageNavbarMobile.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import styles from './PageNavbarMobile.module.scss';
import logo from '../../../images/logo.webp';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '../../Modal/Modal';
import Cotizador from '../../Cotizador/Cotizador';

const PageNavbarMobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [cotizadorOpen, setCotizadorOpen] = useState(false);
  const navigate = useNavigate();

  // Bloquear scroll cuando menú o cotizador estén abiertos
  useEffect(() => {
    document.body.style.overflow = menuOpen || cotizadorOpen ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [menuOpen, cotizadorOpen]);

  const toggleMenu = () => setMenuOpen(prev => !prev);

  const openCotizador = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'navbar_solicitar_cotizacion',
          event_category: 'engagement',
          event_label: 'Solicitud de Cotización - Mobile',
          value: null,
          slug: null
        }
      });
    }
    setMenuOpen(false);
    setCotizadorOpen(true);
  };

  const closeCotizador = () => setCotizadorOpen(false);

  return (
    <>
      <nav className={styles.pageNavbarMobile}>
        <div className={styles.pageNavbarMobileContent}>
          <Link to="/" className={styles.pageNavbarMobileLogo}>
            <img src={logo} alt="Logo" />
          </Link>
          <div className={styles.pageNavbarMobileHamburger} onClick={toggleMenu}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </div>
        </div>

        {menuOpen && (
          <div className={styles.pageNavbarMobileMenu}>
            <Link to="/" onClick={toggleMenu}>INICIO</Link>
            <Link to="/productos" onClick={toggleMenu}>PRODUCTOS</Link>
            <Link to="/servicios" onClick={toggleMenu}>SERVICIOS</Link>
            <Link to="/noticias" onClick={toggleMenu}>NOTICIAS</Link>
            <Link to="/contacto" onClick={toggleMenu}>CONTACTO</Link>
            <div className={styles.navbarMobileCampana} onClick={openCotizador}>
              COTIZAR
            </div>
          </div>
        )}
      </nav>

      <Modal isOpen={cotizadorOpen} onClose={closeCotizador}>
        <Cotizador onClose={closeCotizador} />
      </Modal>
    </>
  );
};

export default PageNavbarMobile;
